import { createSelector } from 'reselect';
import { getFabricDataValues } from './config';
import { getFabricSearchQuery, makeGetFilter } from "./search";
import { calcPresetsAttrsPrices } from './general';

export const excludedColorSet = () => new Set(['принт', 'любой'])

export const excludedStylesSet = () => new Set(['', ' '])

export const splitValues = (valueString) => {
    return valueString.split(',').map((e) => (e.trim()))
}

export const getColors = (list) => {
    let colors = new Set()
    const excluted = excludedColorSet()
    for (let i in list) {
        const item = list[i]
        const clrs = splitValues(item.filterColor);
        for (let i in clrs) {
            const c = clrs[i];
            if (excluted.has(c)) {
                continue;
            }
            colors.add(clrs[i])
        }
    }
    return Array.from(colors)
}

export const getStyles = (list) => {
    let styles = new Set()
    let excluded = excludedStylesSet()
    for (let i in list) {
        const item = list[i];

        const stylesArr = splitValues(item.style);
        for (let i in stylesArr) {
            const c = stylesArr[i].toLowerCase();
            if (excluded.has(c)) {
                continue;
            }
            styles.add(c)
        }
    }
    return Array.from(styles)
}

export const getPatterns = (list) => {
    let patterns = new Set()
    let excluded = excludedStylesSet()
    for (let i in list) {
        const item = list[i];
        const pattern = item.color.toLowerCase();
        if (excluded.has(pattern)) {
            continue;
        }
        patterns.add(pattern);
    }
    return Array.from(patterns)
}

export const getWeaves = (list) => {
    let weaves = new Set()
    let excluded = excludedStylesSet()
    for (let i in list) {
        const item = list[i];
        const weave = item.weave.toLowerCase();
        if (excluded.has(weave)) {
            continue;
        }
        weaves.add(weave);
    }
    return Array.from(weaves).sort()
}

export const getTextColorFilters = () => (
    {
        'белый': {
            id: 'белый',
            displayName: 'Белый',
            textColor: ['белый'],
            hexColor: ['#FFFFFF', '#FFFFFF']
        },
        'серый/черный': {
            id: 'серый/черный',
            displayName: 'Серый/Черный',
            textColor: ['серый', 'черный'],
            hexColor: ['#636467', '#414141']
        },
        'голубой/синий': {
            id: 'голубой/синий',
            displayName: 'Голубой/Синий',
            textColor: ['голубой', 'синий', 'темно-синий'],
            hexColor: ['#C9CDF0', '#5D7E9D']
        },
        'зеленый': {
            id: 'зеленый',
            displayName: 'Зеленый',
            textColor: ['зеленый'],
            hexColor: ['#A9C991', '#7FC07F']
        },
        'желтый': {
            id: 'желтый',
            displayName: 'Желтый',
            textColor: ['желтый', 'оранжевый'],
            hexColor: ['#FEEFB9', '#F7D764']
        },
        'розовый/сиреневый': {
            id: 'розовый/сиреневый',
            displayName: 'Розовый/Сиреневый',
            textColor: ['розовый', 'фиолетовый'],
            hexColor: ['#E395C1', '#A077B3']
        },
        'бежевый/коричневый': {
            id: 'бежевый/коричневый',
            displayName: 'Бежевый/Коричневый',
            textColor: ['бежевый', 'коричневый'],
            hexColor: ['#F8E0C4', '#583D2E']
        },
        'красный/бордовый': {
            id: 'красный/бордовый',
            displayName: 'Красный/Бордовый',
            textColor: ['красный', 'бордовый'],
            hexColor: ['#F43535', '#721414']
        },
    }
)

export const getTextStylesFilters = () => (
    {
        'casual': {
            id: 'casual',
            displayName: 'Casual',
        },
        'business-casual': {
            id: 'business-casual',
            displayName: 'Business Casual',
        },
        'business': {
            id: 'business',
            displayName: 'Business',
        },
        'formal': {
            id: 'formal',
            displayName: 'Formal',
        },
        'tuxedo': {
            id: 'tuxedo',
            displayName: 'Tuxedo',
        },
    }
)

export const getTextPatternsFilters = () => (
    {
        'клетка': {
            id: 'клетка',
            displayName: 'Клетка',
        },
        'однотонная': {
            id: 'однотонная',
            displayName: 'Однотонная',
        },
        'полоска': {
            id: 'полоска',
            displayName: 'Полоска',
        },
        'принт': {
            id: 'принт',
            displayName: 'Принт'
        }
    }
)


export const getTextWeavesFilters = () => (
    {
        'flannel': {
            id: 'flannel',
            displayName: 'Flannel'
        },
        'twill': {
            id: 'twill',
            displayName: 'Twill'
        },
        'melange': {
            id: 'melange',
            displayName: 'Melange'
        },
        'oxford': {
            id: 'oxford',
            displayName: 'Oxford'
        },
        'dobby': {
            id: 'dobby',
            displayName: 'Dobby'
        },
        'poplin': {
            id: 'poplin',
            displayName: 'Poplin'
        },
        'herringbone': {
            id: 'herringbone',
            displayName: 'Herringbone'
        },
        'satin': {
            id: 'satin',
            displayName: 'Satin'
        },
        'royal oxford': {
            id: 'royal oxford',
            displayName: 'Royal Oxford'
        },
        'pinpoint': {
            id: 'pinpoint',
            displayName: 'Pinpoint'
        },
        'end-on-end': {
            id: 'end-on-end',
            displayName: 'End-on-end'
        },
        'seersucker': {
            id: 'seersucker',
            displayName: 'Seersucker'
        }
    }
)

export const extendStyles = (styles, filters, isStyle) => {
    const result = [];
    for (let i in styles) {
        const s = styles[i];
        if (isStyle) {
            if (filters.hasOwnProperty(s)) {
                result[result.length] = filters[s]
            }
        } else {
            for (var f in filters) {
                const textColor = filters[f].textColor.indexOf(s);
                if (textColor > -1) {
                    result[result.length] = filters[f];
                }
            }
        }
    }
    if (!isStyle) {
        const uniqueArray = result.filter(function (item, pos) {
            return result.indexOf(item) == pos;
        })
        const sortingArr = Object.keys(filters);
        uniqueArray.sort(function (a, b) {
            return sortingArr.indexOf(a.id) - sortingArr.indexOf(b.id);
        });
        return uniqueArray
    }
    return result;
}

export const getAvailablePatterns = createSelector(
    getFabricDataValues,
    (fabricData) => {
        const fabricValues = fabricData;
        return getPatterns(fabricValues);
    }
)

export const getAvailableWeaves = createSelector(
    getFabricDataValues,
    (fabricData) => {
        const fabricValues = fabricData;
        return getWeaves(fabricValues);
    }
)

export const getAvailableColors = createSelector(
    getFabricDataValues,
    (fabricData) => {
        const fabricValues = fabricData;
        return getColors(fabricValues);
    }
)

export const getAvailableStyles = createSelector(
    getFabricDataValues,
    (fabricData) => {
        const fabricValues = fabricData;
        return getStyles(fabricValues);
    }
)

export const getAvailableHexColorsExtended = createSelector(
    getAvailableColors,
    getTextColorFilters,
    (s, f) => {
        return extendStyles(s, f)
    }
)

export const getAvailableTextColorsExtended = createSelector(
    getAvailableColors,
    getTextColorFilters,
    (s, f) => {
        return extendStyles(s, f)
    }
)

export const getAvailableStylesColorsExtended = createSelector(
    getAvailableStyles,
    getTextStylesFilters,
    (s, f) => {
        return extendStyles(s, f, true)
    }
)

export const getAvailablePatternsExtended = createSelector(
    getAvailablePatterns,
    getTextPatternsFilters,
    (s, f) => {
        return extendStyles(s, f, true)
    }
)

export const getAvailableWeavesExtended = createSelector(
    getAvailableWeaves,
    getTextWeavesFilters,
    (s, f) => {
        return extendStyles(s, f, true)
    }
)


const searchInArray = (arr, criteria) => {
    const result = [];
    for (let a of arr) {
        for (let c of criteria) {
            if (a === c && result.indexOf(a) === -1) {
                result.push(a);
            }
        }
    }
    return result.length > 0;
}

const getSearchParamsArray = (rawString) => {
    return rawString.toLowerCase().replace(/\s/g, '').split(',');
}

const makeGetFilterSearchCriteria = (criteria) => {
    return function (rawFilterColor) {
        return searchInArray(getSearchParamsArray(rawFilterColor), criteria);
    };
}



const applyFilter = (filter, data, isCatalog) => {

    let filteredData = data;
    if (filter.hasOwnProperty('styles')) {
        if(isCatalog){
            filteredData = filteredData.filter((f) => filter.styles.hasOwnProperty(f.catalog.preset.toLowerCase()));
        }  else {
            filteredData = filteredData.filter((f) => {
                const stylesArr = splitValues(f.style);
                let hasProperty = false;
                stylesArr.forEach(item => {
                    if (filter.styles.hasOwnProperty(item.toLowerCase())) {
                        hasProperty = true;
                    }
                })
                return hasProperty;
            });
        }
    }

    //todo:
    if (filter.hasOwnProperty('colors')) {
        const filteredColors = [];
        const allColors = getTextColorFilters();
        let activeColors = [];
        for (var id in filter.colors) {
            activeColors.push(...allColors[id].textColor);
        }
        filteredData.forEach(product => {
            let productColors = getSearchParamsArray(product.filterColor);
            for(let i = 0; i < activeColors.length; i++) {
                let activeColor = activeColors[i];
                if(productColors.indexOf(activeColor) !== -1) {
                    filteredColors.push({ ...product });
                    break;
                }
            }
        })
        filteredData = filteredColors;
    }
    if (filter.hasOwnProperty('patterns')) {
        filteredData = filteredData.filter((f) => filter.patterns.hasOwnProperty(f.color.toLowerCase()));
    }
    if (filter.hasOwnProperty('weaves')) {
        filteredData = filteredData.filter((f) => filter.weaves.hasOwnProperty(f.weave.toLowerCase()));
    }
    if (filter.hasOwnProperty('sale') && filter.sale.sale) {
        filteredData = filteredData.filter((f) => String(f.isSale).toLowerCase() === 'true');
    }
    return filteredData;
}

export const getActiveFabricFilter = (state) => state.ui.activeFabricFilters;

export const getFilteredFabricDataValues = createSelector(
    getFabricDataValues,
    getActiveFabricFilter,
    (data, filter) => {
        return applyFilter(filter, data);
    });

export const getFabricDataWithFiltersAndSearch = createSelector(
    getFabricDataValues,
    getFabricSearchQuery,
    getActiveFabricFilter,
    (fabricDataValues, fabricSearQuery, activeFabricFilter) => {
        let result = fabricDataValues;
        if (Boolean(fabricSearQuery)) {
            const searchFilter = makeGetFilter(fabricSearQuery);
            result = result.filter(searchFilter);
        }
        if (activeFabricFilter && Object.keys(activeFabricFilter).length > 0) {
            result = applyFilter(activeFabricFilter, result)
        }
        return result;
    }
)

export const getCatalogImgSrc = (article, preset) => `${article}-${preset}`;
export const getFromattedPreset = (preset) => preset === 'business casual' ? 'business-casual' : preset;

export const getFabricDataForCatalog = createSelector(
    getFabricDataValues,
    calcPresetsAttrsPrices,
    (result, prices) => {
        let resultRefac = [];

        const notShowThis = [
            'Coupon12990', 'Coupon14990', 
            'Coupon16990', 'Coupon18990', 
            'Coupon20990', 'Coupon25990', 
            '0ae71decdcd5907c5c3c6b94bf23613a5cf83fad', 
            'df7ea3d0a16bbc36b46a2b142aace32ee4f4ae9b', 
        ];

        result.forEach((product, i) => {
            let newProduct = { ...product };
            // не показывать рубахи без стиля B)
            if(!newProduct.style) {
                return false;
            }
            // не показывать эти элементы
            if(notShowThis.indexOf(String(newProduct.objectId)) !== -1) {
                return false;
            }

            let fabricStyles = newProduct.style.split(',').map(e => e.trim().toLowerCase());

            fabricStyles.forEach(preset => {
                preset = getFromattedPreset(preset);

                newProduct.catalog = {
                    imgSrc: getCatalogImgSrc(newProduct.article.toLowerCase(), preset),
                    preset: preset,
                    price: Number(newProduct.price) + prices[preset],
                }
                resultRefac.push({ ...newProduct });
            })
        })
        return resultRefac;
    }
)

export const getFilteredDataForCatalog = createSelector( 
    getActiveFabricFilter,
    getFabricDataForCatalog,
    (activeFabricFilter, data) => {
        return applyFilter(activeFabricFilter, data, true);
    }
)

const getFabricEnumChunks = values => splitArray(values, 3000) || [];

const splitArray = (array, chunkSize) => {
    return [].concat.apply([],
        array.map(function (elem, i) {
            return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
        })
    )
}

export const getFiltersCount = createSelector(
    getActiveFabricFilter,
    filters => {
        return Object.values(filters).reduce((
            acc, item) => (acc + Object.values(item).length), 0
        )
    }
)

export const getChunkedFabrics = createSelector(
    getFabricDataWithFiltersAndSearch,
    fabricData => {
        return getFabricEnumChunks(fabricData);
    })

export const makeGetFabricChunk = (page) => (
    createSelector(
        getChunkedFabrics,
        chunks => (
            chunks && chunks.length > 0 ?
                {
                    chunks: chunks[page],
                    total: chunks.length
                } :
                {
                    chunks: [],
                    total: 0
                }

        )
    )
)

